import type { ScreenSchema } from './types';

const carouselSchema: ScreenSchema = {
  template: 'carousel',
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    },
    slide: {
      iterate: 'slides',
      keyPrefix: 'slide',
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
  }
};

export default carouselSchema;
